import { formatDistanceToNow } from 'date-fns';

/**
 * Format a timestamp as relative time (e.g., "2 hours ago", "3 days ago")
 */
export function formatTimeAgo(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return 'Unknown';
    }
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
    return 'Unknown';
  }
}
